import { render, staticRenderFns } from "./Communities.vue?vue&type=template&id=4b7ddb5e&"
import script from "./Communities.vue?vue&type=script&lang=js&"
export * from "./Communities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/users/averton/apps/averton/web/app/themes/averton-1865/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7ddb5e')) {
      api.createRecord('4b7ddb5e', component.options)
    } else {
      api.reload('4b7ddb5e', component.options)
    }
    module.hot.accept("./Communities.vue?vue&type=template&id=4b7ddb5e&", function () {
      api.rerender('4b7ddb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/js/vue/Communities.vue"
export default component.exports